import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button, Typography } from '@material-ui/core';

import { SearchInput } from 'components';
import { leadActions } from '_actions';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  }
}));

const LeadsToolbar = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  const handleClick = (event) => {
    props.toggleFormEnabled();
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>
        <Typography variant="h3">#{props.leadId} {props.leadname}</Typography> 
        <span className={classes.spacer} />
        <Button
          color="primary"
          variant="contained"
          onClick={handleClick}
        >Edit</Button>
      </div>
    </div>
  );
};

LeadsToolbar.propTypes = {
  className: PropTypes.string
};

export default LeadsToolbar;
